import { useTranslation } from 'react-i18next';
import { Moon, Sun } from 'lucide-react';

import { useThemeStore } from '../theme/themeStore';
import { Button } from './Button';

/**
 * Przełącznik motywu.
 *
 * Etykieta mówi, co się STANIE po kliknięciu, a nie jaki motyw jest teraz —
 * przycisk opisany stanem bieżącym jest dwuznaczny dla każdego, kto nie widzi
 * ekranu („Motyw ciemny" to informacja czy polecenie?).
 */
export function ThemeToggle() {
  const { t } = useTranslation();
  const resolved = useThemeStore((state) => state.resolved);
  const toggle = useThemeStore((state) => state.toggle);

  const next = resolved === 'dark' ? 'light' : 'dark';

  return (
    <Button
      variant="ghost"
      onClick={toggle}
      aria-label={`${t('common.theme.toggle')}: ${t(`common.theme.${next}`)}`}
      title={t('common.theme.toggle')}
    >
      {/* ⛔ Ikona, nie znak czcionki (spec 12B.7): „☀" bywa kolorowym emoji, które
          ignoruje `color`, więc przycisk motywu nie brałby barwy z motywu. */}
      {resolved === 'dark' ? (
        <Sun size={16} aria-hidden="true" />
      ) : (
        <Moon size={16} aria-hidden="true" />
      )}
    </Button>
  );
}
